module.exports = __webpack_public_path__ + "media/assets/fonts/Poppins-Regular-8081832fc5cfbf634aa664a9eff0350e.ttf";